import styled, { css } from 'styled-components'
import transparencyMask from './transparency-mask.png'
import {
  ItemContainerColor,
  BIG_CONTAINER_WIDTH,
  BIG_CONTAINER_HEIGHT,
} from '../../components/Grid'
import { breakpoint } from 'utils'

const CONTAINER_WIDTH = 200
const CONTAINER_HEIGHT = 128
const SWATCH_SIZE = 64
const SWATCH_BIG_SIZE = BIG_CONTAINER_WIDTH / 3

export const ColorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  width: ${CONTAINER_WIDTH}px;
  height: ${CONTAINER_HEIGHT}px;
  margin-bottom: 4px;
  background-color: ${ItemContainerColor};
  border-radius: 6px;

  ${breakpoint('xxl')`
    height: ${BIG_CONTAINER_HEIGHT}rem;
    width: ${BIG_CONTAINER_WIDTH}rem;
  `};
`

const swatchStyle = css`
  height: ${SWATCH_SIZE}px;
  width: ${SWATCH_SIZE}px;
  position: absolute;
  top: ${(CONTAINER_HEIGHT - SWATCH_SIZE) / 2}px;
  left: ${(CONTAINER_WIDTH - SWATCH_SIZE) / 2}px;
  border-radius: ${({ theme }) => theme.radii.rounded};

  ${breakpoint('xxl')`
        height: ${SWATCH_BIG_SIZE}rem;
        width: ${SWATCH_BIG_SIZE}rem;
        top: ${(BIG_CONTAINER_HEIGHT - SWATCH_BIG_SIZE) / 2}rem;
        left: ${(BIG_CONTAINER_WIDTH - SWATCH_BIG_SIZE) / 2}rem;
    `};
`

export const ColorSwatch = styled.div<{
  backgroundColor: string
}>(
  ({ backgroundColor }) => css`
    ${swatchStyle}
    background-color: ${backgroundColor};
    border: 1px solid ${({ theme }) => theme.colors.border.dark.base};
    z-index: ${({ theme }) => theme.zIndex[1]};
  `
)
export const ColorSwatchMask = styled.div`
  ${swatchStyle}
  background: url(${transparencyMask});
  background-size: 30%;
`

export const ColorDetail = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.smaller};
    text-transform: uppercase;
    color: ${theme.colors.foreground.secondary[4]};
  `
)

export const ColorDetailName = styled.span(
  ({ theme }) => css`
    display: block;
    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.foreground.secondary[1]};
  `
)
